/*
*   Main page that renders levels within a quiz
*   assigned to a user
*/
import Styles from './QuizLevel.module.scss';
import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

// Components import.
import { useAPI, Message } from 'components/lib';
import QuizViewCard from 'components/global/QuizViewCard/QuizViewCard';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';
import { BreadCrumbs } from 'components/global/BreadCrumbs/BreadCrumbs';

export function QuizLevel(props) {
	const { c_quiz_id } = useParams();

	const navigate = useNavigate();

	const handleClick = (data) => {
		const id = data;
		navigate(`/quizzes/${c_quiz_id}/level/${id}/quiz/attempt`);

	};

	const [quizLevelList, setQuizLevelList] = useState([]);
	const { data, loading } = useAPI(`/api/user/quizzes/${c_quiz_id}/levels`, 'GET');
	useEffect(() => {
		if (data?.length) {
			const updatedQuizLevelList = data.map(level => ({
				...level,
				isDisabled: (level.status === "Not Started" || level.attempts === 3),
				isCompleted: (level.status === "Completed"),
				buttonText: (level.status === "Not Started") ? "Locked" :
					level.attempts === 3 ? "Exceed" :
						(level.status === "Completed") ? "Completed" :
							level.status === "Failed" ? "Retake" :
								"Start"
			}));
			setQuizLevelList(updatedQuizLevelList);
		}

	}, [data]);
	return (
		<>
			<Message
				closable
				title={props.t('CommonQuiz.QuizLevel.message.title')}
				text={props.t('CommonQuiz.QuizLevel.message.descr')}
				type="info"
			/>
			<div className={Styles.CardContainer}>
				<>
					<div className={Styles.tabContainer}>
						<BreadCrumbs
							onClickPaths={[
								'/quiz',
								''
							]}
							crumbs={[
								props.t('CommonQuiz.QuizLevel.breadCrumbs.quiz'),
								quizLevelList[0]?.quizname ? props.t('CommonQuiz.QuizLevel.breadCrumbs.quizLevel', { levelName: quizLevelList[0]?.quizname }) : props.t('CommonQuiz.QuizLevel.breadCrumbs.levels')
							]}
						/>
					</div>
					<div style={{ display: 'flex', flexWrap: 'wrap' }}>
						{loading ?
							<div>
								<LoadingBackdrop isOpen={true} />
							</div>
							: quizLevelList.length > 0
								? quizLevelList.map((level) =>
									<QuizViewCard
										data={level}
										key={level.id}
										onStartClick={handleClick}
										button_text={level.buttonText} />)
								: props.t('CommonQuiz.QuizLevel.info')}
					</div>
				</>
			</div>
		</>
	);
}
